export default {"src":"/_next/static/media/yt-blu.3a947518.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};